import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchLeaveTypeData = createAsyncThunk("fetchLeaveTypeData", async (token) => {
  // const token = useSelector((state) => state.auth.token);

  const getLeaveType = CryptoJS.SHA256("/getLeaveType" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const response = await fetch(`${env.backend_api_endpoint}/${getLeaveType}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  });
  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  // ✅ Return the full response (status, message, and decrypted data)
  return resData;
}
);

const leaveTypeDataSlice = createSlice({
  name: "getLeaveType",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLeaveTypeData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeaveTypeData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchLeaveTypeData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default leaveTypeDataSlice.reducer;
